import { render, staticRenderFns } from "./VenueTable.vue?vue&type=template&id=71c86abd"
import script from "./VenueTable.vue?vue&type=script&lang=ts"
export * from "./VenueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports